import { useState } from "react";
import { faqList } from "@/mocks/gossip";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" data-anchor className="bg-background-50">
      <div className="mx-auto w-full max-w-4xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <p className="mb-2 flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wider text-primary-600">
            <i className="ri-question-answer-line text-base" aria-hidden="true" />
            常见问题
          </p>
          <h2 className="text-2xl font-black text-foreground-950 md:text-4xl">吃瓜前先了解一下</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            关于在线围观、评论区见、瓜团讨论的常见疑问，这里一次说清。
          </p>
        </div>

        <div className="mt-9 flex flex-col gap-3">
          {faqList.map((f, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open ? "border-accent-300 bg-accent-50/50" : "border-background-200 bg-background-100/40"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : idx)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <h3 className="text-base font-bold text-foreground-950">{f.q}</h3>
                  <span
                    className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full transition-colors ${
                      open ? "bg-accent-600 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={open ? "ri-subtract-line text-lg" : "ri-add-line text-lg"} aria-hidden="true" />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6 md:text-base">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}